import {
  AttendContactLeaveEarlyEntity,
} from './attendContactLeaveEarlyEntity';
import { ChildId } from './valueObjects/childId';
import { LeaveEarlyDateTime } from './valueObjects/leaveEarlyDateTime';
import { Memo } from './valueObjects/memo';
import { NurseryId } from './valueObjects/nurseryId';
import { ParentId } from './valueObjects/parentId';

import type {
  AttendContactLeaveEarlyPropsPub,
  AttendContactLeaveEarlyPropsPvt,
} from './attendContactLeaveEarlyEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { AttendContactLeaveEarlyJsonPub, AttendContactLeaveEarlyJsonPvt } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class AttendContactLeaveEarlyFactory extends FactoryPub<
  AttendContactLeaveEarlyEntity,
  AttendContactLeaveEarlyPropsPvt,
  AttendContactLeaveEarlyJsonPvt,
  AttendContactLeaveEarlyPropsPub,
  AttendContactLeaveEarlyJsonPub
> {
  comparePub = (
    a: EntityDataPubType<AttendContactLeaveEarlyJsonPvt, AttendContactLeaveEarlyJsonPub>,
    b: EntityDataPubType<AttendContactLeaveEarlyJsonPvt, AttendContactLeaveEarlyJsonPub>,
  ) => {
    const da = new Date(a.data.leaveEarlyDateTime);
    const db = new Date(b.data.leaveEarlyDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: AttendContactLeaveEarlyPropsPvt,
    propsPub: EntityPubNotNullType<AttendContactLeaveEarlyPropsPub>,
  ): AttendContactLeaveEarlyEntity {
    return new AttendContactLeaveEarlyEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<AttendContactLeaveEarlyJsonPvt, AttendContactLeaveEarlyJsonPub>,
  ): AttendContactLeaveEarlyEntity {
    return this.create({
      nurseryId: NurseryId.create(props.data.nurseryId),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      leaveEarlyDateTime: LeaveEarlyDateTime.create(new Date(props.data.leaveEarlyDateTime)),
      memo: Memo.create(props.data.memo),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
